/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'

import { Dialog } from 'primereact/dialog';
import { InputText  } from 'primereact/inputtext';
import { RadioButton } from 'primereact/radiobutton';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';

import { rexgexEmail, StatusConst } from '@constants/general'

class ContactModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      nombre: '',
      correo: '',
      estatus: 1,
      errors: [],
      btnSubmitLoading: false
    }
  }

  componentDidMount() {
    this.setState({
      nombre: this.props.nombre || '',
      correo: this.props.correo || '',
      loadingPage: false
    })
    if (this.props.isEdit) this.setState({estatus: this.props.estatus})
  }

  onSubmit = async (e) => {
    e.preventDefault();
    const { onContinueAction, onHidden, isEdit } = this.props
    const { nombre, correo, estatus, justification } = this.state
    this.setState({btnSubmitLoading: true})
    const validate = await this.validateFieldsReject()
    if (some(validate, {})) return this.setState({btnSubmitLoading: false})
    const data = {
      nombre
    }
    if (isEdit) data.estatus = estatus
    else data.correo = correo
    await onContinueAction(data, justification)
    this.setState({btnSubmitLoading: false})
    return onHidden()
  }

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  validateFieldsReject = async () => {
    const { t, isEdit } = this.props
    const { nombre, correo, justification } = this.state
    let errors = {}
    if (!nombre) errors = { ...errors, 'nombre': `${t('Nombre')} ${t('es requerido')}`}
    if (!isEdit) {
      if (!correo) errors = { ...errors, 'correo': `${t('Correo electrónico')} ${t('es requerido')}`}
      else if (!rexgexEmail.test(correo)) errors = { ...errors, 'correo': `${t('El formato de correo es inválido')}`}
    }
    if (!justification) errors = { ...errors, 'justification': `${t('Justificación del cambio')} ${t('es requerido')}`}

    this.setState({errors})
    return errors
  }

  onChange = ({ target }) => {
    this.setState({ [target.name]: target.value }, this.validateFieldsOnchange(target.name, target.value));
  };

  isFormFieldValid = (name) =>
    !!(this.state.errors[name]);

  getFormErrorMessage = (name) =>
    this.isFormFieldValid(name) && (
      <small className="p-error">{this.state.errors[name]}</small>
    );
  
  render () {
    const { t, display, title, onHidden, label, btnOkLabel, description, isEdit } = this.props
    const { nombre, correo, estatus, loadingPage, btnSubmitLoading } = this.state

    const children = loadingPage ? '' : (
      <form className="p-mt-2 p-fluid" onSubmit={this.onSubmit}>
        <div className="p-col">
          <label className="">{description}</label>
        </div>
        <div className="col-12  p-field">
          <label className="p-text-bold p-pb-2">{label || t('Nombre')}</label>
          <InputText
            name="nombre"
            onChange={this.onChange}
            value={nombre}
            className={classNames({
              'p-invalid': this.isFormFieldValid(`nombre`),
            })}
          />
          {this.getFormErrorMessage(`nombre`)}
        </div>
        { isEdit ? (
          <div className="col-12  field-radiobutton">
            <div className='p-mt-4'>
                <RadioButton
                  inputId="estatus"
                  name="estatus"
                  value={StatusConst.IS_ACTIVE}
                  onChange={this.onChange}
                  checked={estatus === StatusConst.IS_ACTIVE}
                />
              <label className="p-pl-2">{t('Activo')}</label>
            </div>
            <div className='p-mt-4'>
                <RadioButton
                  inputId="estatus"
                  name="estatus"
                  value={StatusConst.IS_SUSPENDED}
                  onChange={this.onChange}
                  checked={estatus === StatusConst.IS_SUSPENDED}
                />
              <label className="p-pl-2">{t('Suspendido')}</label>
            </div>
          </div>
        ) : (
          <div className="col-12  p-field">
            <label className="p-text-bold p-pb-2">{label || t('Correo electrónico')}</label>
            <InputText
              name="correo"
              onChange={this.onChange}
              value={correo}
              className={classNames({
                'p-invalid': this.isFormFieldValid(`correo`),
              })}
            />
            {this.getFormErrorMessage(`correo`)}
          </div>
        )}
        <div className='p-col-12'>
          <label className="">{t('Justificación del cambio')}</label>
          <InputTextarea
            name="justification"
            onChange={(e) =>
              this.setState({ justification: e.target.value }, this.validateFieldsOnchange('justification', e.target.value))
            }
            rows={5}
            cols={30}
            className={classNames({
              'p-invalid': this.isFormFieldValid(`justification`),
            })}
          />
          {this.getFormErrorMessage(`justification`)}
        </div>
        <div className="p-dialog-footer custom">
          <div>
            <Button
              label={t('Cerrar')}
              type="button"
              className="p-button-secondary p-button-text p-button-raised"
              onClick={() => onHidden()}
            />
            <Button
              label={btnOkLabel || 'Continuar'}
              type="submit"
              className="p-button-primary"
              loading={btnSubmitLoading}
            />
          </div>
        </div>
      </form>
    )
    if (loadingPage) return true;

    return (
      <Dialog
        header={title || t('Gestor')}
        visible={display}
        breakpoints={{'960px': '90vw'}}
        style={{ width: '60vw' }}
        onHide={onHidden}
      >
        {children}
      </Dialog>
    )
  }
}



export default compose(
  withTranslation()(ContactModal))